"use client"

import { useMutation } from "@tanstack/react-query"
import {
  submitEnterpriseInquiryAction,
  type EnterpriseInquiryInput,
  type EnterpriseInquiryResult,
} from "@/server-actions/enterprise-inquiry"
import { withQueryHandling } from "@/lib/with-query-handling"

export type EnterpriseInquiryMutationInput = EnterpriseInquiryInput & {
  setErrors?: (errors: Record<string, unknown>) => void
}

export function useEnterpriseInquiryMutation() {
  return useMutation({
    mutationFn: async ({
      setErrors,
      ...input
    }: EnterpriseInquiryMutationInput): Promise<EnterpriseInquiryResult> => {
      return withQueryHandling(submitEnterpriseInquiryAction(input), {
        loading: "Sending your request...",
        success: "Enterprise request sent",
        setErrors,
      }) as Promise<EnterpriseInquiryResult>
    },
  })
}
